// apps/web/src/pages/admin/shared/SourceTag.tsx — Phase 5 plan 05-04 (D-24).
//
// Small inline tag for the 3-value reservation source per 04-PATTERNS
// `RESERVATION_SOURCES`. All three variants render `tag-neutral` per
// D-24 — the source is binary info, not a state.

import { useTranslation } from "react-i18next";

export type ReservationSourceValue = "ONLINE" | "TELEFON" | "VOR_ORT";

export function SourceTag({ source }: { source: ReservationSourceValue }) {
  const { t } = useTranslation();
  return (
    <span className="tag tag-neutral" data-testid={`source-tag-${source}`}>
      {t(`source.${source}`)}
    </span>
  );
}
